import React from "react";
import RecommendationEngineSection from "../../components/b2cComponents/RecommendationEngineSection";
import "./RecommendationEnginePage.scss";
const RecommendationEnginePage = () => {
  return (
    <>
      <RecommendationEngineSection isDetailPage={false}/>
    </>
  );
};

export default RecommendationEnginePage;
